import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const PUBLIC_AUTH_KEYS_QUERY_KEY = 'publicAuthKey';

export function useGetPublicAuthKey({
	impersonationContext,
	enabled = true,
	keyId,
	refetchOnWindowFocus = true,
	meta,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	keyId?: string;
	refetchOnWindowFocus?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<string>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `public/auth/key/${keyId}`,
				}),
				'GET'
			);
		},
		enabled,
		refetchOnWindowFocus,
		queryKey: [PUBLIC_AUTH_KEYS_QUERY_KEY, impersonationContext, keyId],
		meta,
	});
}
